<template>
  <div
    id="messages-header">
    <!-- New Assign -->
    <!-- <AssignConversationInfoBox
      v-if="numberMembers && activeConversation && numberMembers[activeConversation.business_id] && numberMembers[activeConversation.business_id].length > 1" /> -->
    <!-- Assign -->
    <!--    <div-->
    <!--      style="display: none !important;"-->
    <!--      class="action-item flex assignment-select">-->
    <!--      <span class="assigned-number rounded-button cursor-default">+385985936321</span>-->
    <!--      <div-->
    <!--        class="dropdown-wrapper"-->
    <!--        :class="{disabled: currentFolder !== 'open'}">-->
    <!--        <div-->
    <!--          class="action-button assign-button rounded-button"-->
    <!--          @click="toggleMemberList"> &lt;!&ndash; click if currentFolder !== open &ndash;&gt;-->
    <!--          <p class="nav d-inline-block">-->
    <!--            {{ assignedMember ? `${assignedMember.first_name} ${assignedMember.last_name}` : 'Unassigned' }} &lt;!&ndash; name can go out from members &ndash;&gt;-->
    <!--          </p>-->
    <!--          <img-->
    <!--            src="~@/assets/img/arrow.svg"-->
    <!--            alt="open assignment menu">-->
    <!--        </div>-->
    <!--        <div-->
    <!--          v-if="showMemberList"-->
    <!--          v-click-outside="hideMembers"-->
    <!--          class="assign-dropdown">-->
    <!--          <div class="dropdown-header">-->
    <!--            <h3>Assign to</h3>-->
    <!--            <b-form-input-->
    <!--              v-model="memberQuery"-->
    <!--              placeholder="Search" />-->
    <!--          </div>-->

    <!--          <div class="dropdown-body">-->
    <!--            <ScrollArea-->
    <!--              style="max-height: 500px;">-->
    <!--              <template v-for="team in teamList">-->
    <!--                <div-->
    <!--                  v-if="team.users.length"-->
    <!--                  :key="team.id"-->
    <!--                  class="team">-->
    <!--                  <div class="team-title">{{ team.name }}</div>-->
    <!--                  <SBAvatar-->
    <!--                    v-if="!memberQuery"-->
    <!--                    :class="{selected: !assignedMember }"-->
    <!--                    class="team-member"-->
    <!--                    size="xs-button"-->
    <!--                    :show-data="true"-->
    <!--                    :show-client="true"-->
    <!--                    :show-name="true"-->
    <!--                    :person="{name: 'Unassigned'}"-->
    <!--                    :show-availability-status="true"-->
    <!--                    @click="assignTo()"/>-->
    <!--                  <div-->
    <!--                    v-for="member in team.users"-->
    <!--                    :key="member.id"-->
    <!--                    :class="{selected: (assignedMember && (assignedMember.id === member.id)) }"-->
    <!--                    class="team-member"-->
    <!--                    @click="assignTo(member.id)">-->
    <!--                    <div class="user-data greedy">-->
    <!--                      <SBAvatar-->
    <!--                        size="xs-button"-->
    <!--                        :show-data="true"-->
    <!--                        :show-client="true"-->
    <!--                        :show-name="true"-->
    <!--                        :person="member"-->
    <!--                        :show-availability-status="true"/>-->
    <!--                    </div>-->
    <!--                    <span-->
    <!--                      v-if="activeConversation.user_id === member.id && activeConversation.business_id === team.id"-->
    <!--                      class="done-tick" />-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--              </template>-->
    <!--            </ScrollArea>-->
    <!--          </div>-->

    <!--          &lt;!&ndash; <div class="c-dropdown-items scroll-area">-->
    <!--            <div-->
    <!--              v-if="!memberQuery"-->
    <!--              :class="{selected: !assignedMember }"-->
    <!--              class="c-dropdown-item"-->
    <!--              @click="assignTo()">-->
    <!--              <div class="user-data">-->
    <!--                <div class="user-info">-->
    <!--                  <h6 style=" margin-left: 40px">Unassigned</h6>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <template v-for="team in teams">-->
    <!--              <div-->
    <!--                v-if="team.users.length"-->
    <!--                :key="team.id"-->
    <!--                class="team">-->
    <!--                <div class="team-title">{{ team.name }}</div>-->
    <!--                <div-->
    <!--                  v-for="member in team.users"-->
    <!--                  :key="member.id"-->
    <!--                  :class="{selected: (assignedMember && (assignedMember.id === member.id)) }"-->
    <!--                  class="c-dropdown-item"-->
    <!--                  @click="assignTo(member.id)">-->
    <!--                  <div class="user-data">-->
    <!--                    <span-->
    <!--                      :style="member.avatar ? `background-image: url(${member.avatar})` : ''"-->
    <!--                      class="user-avatar">-->
    <!--                      {{ member.avatar ? '' : member.name | initials }}-->
    <!--                      <span-->
    <!--                        v-if="member.online && member.available"-->
    <!--                        class="indicator green"/>-->
    <!--                    </span>-->
    <!--                    <div class="user-info">-->
    <!--                      <h6>-->
    <!--                        {{ member.name }}-->
    <!--                      </h6>-->
    <!--                      <span class="email">{{ member.email }}</span>-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </template>-->
    <!--          </div> &ndash;&gt;-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <SBAvatar
      v-if="true"
      :class="{}"
      class="team-member person-avatar"
      size="m-button"
      :show-data="true"
      :show-client="true"
      :show-name="true"
      :show-phone="true"
      :person="activeConversation.contact"
      :character-count="1"
      @action="activateSection('info')" />
    
    <div class="greedy" />

    <!-- CLOSE / RELOAD -->
    <b-button
      pill
      class="p-0 no-focus">
      <SBIcon
        v-if="activeConversation.folder === 'open'"
        id="done-icon"
        :icon="SBIconList.DONE_TICK_THIN"
        :color="SBColors.blackPrimary"
        :hover-size="28"
        :border-radius="50"
        :size="12"
        :pointer="true"
        @click="moveToFolder('done')" />
      <SBIcon
        v-else-if="['done', 'spam'].includes(activeConversation.folder)"
        id="reopen-icon"
        :icon="SBIconList.REFRESH_THICK"
        :color="SBColors.blackPrimary"
        :hover-size="28"
        :border-radius="50"
        :size="12"
        :pointer="true"
        @click="moveToFolder('open')" />
    </b-button>

    <!-- MENU -->
    <b-button
      pill
      class="p-0 no-focus" >
      <SBIcon
        id="menu-icon"
        ref="menuIconRef"
        :icon="SBIconList.THREE_DOTS"
        :color="SBColors.blackPrimary"
        :hover-size="28"
        :border-radius="50"
        :size="12"
        :pointer="true"
        @click="toggleMenu" />
    </b-button>

    <AssignConversationInfoBox
      v-if="activeConversation && numberMembers && numberMembers[activeConversation.business_id] && numberMembers[activeConversation.business_id].length > 1"
      class="action-btn assign-btn" />

    <!-- FOLLOW -->
    <b-button
      id="follow-button"
      pill
      class="p-0 no-focus flex flex-align-center pl-1 pr-2"
      @click="handleFollowClick" >
      <SBIcon
        :icon="isFollowing ? SBIconList.DONE_TICK_THIN : SBIconList.EYE_OPEN_FILL"
        :color="SBColors.blackPrimary"
        :hover-size="28"
        :border-radius="50"
        :size="isFollowing ? 12 : 14"
        :pointer="true" />
      <p>{{ isFollowing ? 'Following' : 'Follow' }}</p>
    </b-button>

    <!-- <div
      v-if="folderChangingAbility"
      v-click-outside="hideMessageActions"
      class="button-box">
      <span
        class="action-open"
        @click="toggleMessageActions">
        <icon name="ellipsis-v"/>
      </span>
      <div
        :class="{ opened: messageActionButtonsOpened }"
        class="action-list">
        <template v-if="currentFolder === 'open'">
          <span
            id="bot-status-button"
            class="action-button bot-status"
            @click="toggleBotActivation">
            <img
              v-if="activeConversation.bot_active"
              src="~@/assets/img/bot-active.svg">
            <img
              v-else
              src="~@/assets/img/bot-inactive.svg">
            <b-tooltip
              target="bot-status-button"
              placement="bottom"
              offset="5, 0"
              no-fade>
              <div
                id="bot-status-tooltip"
                :class="activeConversation.bot_active ? 'active' : 'inactive'">
                <template v-if="activeConversation.bot_active">
                  <h6><icon name="circle"/> Bot Turned On</h6>
                  <p>Turn keyword recognition off.</p>
                </template>
                <template v-else>
                  <h6><icon name="circle"/> Bot Turned Off</h6>
                  <p>Turn keyword recognition on.</p>
                </template>
              </div>
            </b-tooltip>
          </span>
          <span
            id="read-message-button"
            class="action-button conversation-seen"
            @click="toggleConversationSeen">
            <img
              v-if="conversationIsUnread"
              src="~@/assets/img/message-unread.svg">
            <img
              v-else
              src="~@/assets/img/message-read.svg">
            <b-tooltip
              target="read-message-button"
              placement="bottom"
              offset="5, 0"
              no-fade>
              <div
                id="read-message-tooltip"
                :class="conversationIsUnread ? 'inactive' : 'active'">
                <template v-if="conversationIsUnread">
                  <h6>Unread</h6>
                  <p>Mark conversation as read.</p>
                </template>
                <template v-else>
                  <h6>Read</h6>
                  <p>Mark conversation as unread.</p>
                </template>
              </div>
            </b-tooltip>
          </span>
          <span class="float-right">
            <span
              class="btn btn-main btn-round danger"
              @click="moveToFolder('spam')">
              <icon name="trash-alt"/> Spam
            </span>
            <span
              class="btn btn-main btn-round success"
              @click="moveToFolder('done')">
              <icon name="check"/> Done
            </span>
          </span>
        </template>
        <div v-else-if="['done', 'spam'].includes(currentFolder)">
          <span class="float-right">
            <span
              class="btn btn-main btn-round open"
              @click="moveToFolder('open')">
              <img src="~@/assets/img/chat-open.svg"> Move to Open
            </span>
          </span>
        </div>
      </div>
    </div> -->

    <!-- Popovers -->
    <b-popover
      v-if="currentFolder === 'open'"
      ref="donePopoverRef"
      target="done-icon"
      triggers="hover"
      placement="bottom"
      custom-class="basic-popover btn-popover-additional-margin">
      Move to Done
    </b-popover>
    <b-popover
      v-if="['done', 'spam'].includes(currentFolder)"
      ref="reopenPopoverRef"
      target="reopen-icon"
      triggers="hover"
      placement="bottom"
      custom-class="basic-popover btn-popover-additional-margin">
      Move to Open
    </b-popover>
    <b-popover
      v-if="!blockMenuInfoPopover"
      target="menu-icon"
      triggers="hover"
      placement="bottom"
      custom-class="basic-popover btn-popover-additional-margin">
      More actions
    </b-popover>
    <b-popover
      target="follow-button"
      triggers="hover"
      placement="bottom"
      custom-class="big follow-popover-max-width">
      <div class="flex flex-column">
        <h1>{{ isFollowing ? 'Unfollow this conversation' : 'Follow this conversation' }}</h1>
        <p>{{ isFollowing ? 'Unfollow this conversation to remove it from your My Chats folder.' : 'Follow this conversation to make it visible in your My Chats folder.' }}</p>
      </div>
    </b-popover>

    <!-- TODO - create a component from this which has a content slot -->
    <b-popover
      ref="menuPopoverRef"
      target="menu-icon"
      triggers="manual"
      placement="bottomleft"
      custom-class="interactive-popover popover-offset-sb hide-arrow mt-0"
      container="messages-header"
      boundary-padding="0" >
      <div
        id="select-branch"
        v-click-outside="closeMenu" >
        <h5>Actions</h5>
        <ul
          ref="branchesWrapperRef"
          class="branch-list">
          <!-- (Un)Read option -->
          <li @click="toggleConversationSeen()" >
            <div class="option-info flex flex-align-center greedy">
              <SBIcon
                :icon="conversationIsUnread ? SBIconList.CONVERSATION_READ : SBIconList.CONVERSATION_UNREAD"
                :color="SBColors.blackPrimary"
                :size="15" />
              <h3 class="ellipsis" >{{ conversationIsUnread ? 'Mark as read' : 'Mark as unread' }}</h3>
            </div>
          </li>

          <!-- Block option -->
          <li
            v-if="!conversationIsBlocked"
            @click="blockContact()" >
            <div class="option-info flex flex-align-center greedy">
              <SBIcon
                :icon="SBIconList.BLOCK"
                :color="SBColors.blackPrimary"
                :size="15" />
              <h3
                class="ellipsis" >Block contact</h3>
            </div>
          </li>
          <li
            v-else
            @click="unblockContact()" >
            <div class="option-info flex flex-align-center greedy">
              <SBIcon
                :icon="SBIconList.BLOCK"
                :color="SBColors.blackPrimary"
                :size="15" />
              <h3
                class="ellipsis" >Unblock contact</h3>
            </div>
          </li>

          <!-- Bot option -->
          <li
            v-if="activeConversation"
            @click="toggleBotActivation()" >
            <div class="option-info flex flex-align-center greedy">
              <SBIcon
                :icon="activeConversation.bot_active ? SBIconList.BOT_OFF : SBIconList.BOT_ON"
                :color="SBColors.blackPrimary"
                :size="15" />
              <div>
                <h3
                  class="ellipsis" >{{ activeConversation.bot_active ? 'Turn bot off' : 'Turn bot on' }}</h3>
                <p
                  class="ellipsis">{{ activeConversation.bot_active ? 'Automated responses are currently on' : 'Automated responses are currently off' }}</p>
              </div>
            </div>
          </li>

          <!-- Download chat option -->
          <li
            v-if="activeConversation"
            :class="{ disabled: downloadingChat }"
            @click="downloadChat()" >
            <div class="option-info flex flex-align-center greedy">
              <SBIcon
                :icon="SBIconList.DOWNLOAD"
                :color="SBColors.blackPrimary"
                :size="15" />
              <h3 class="ellipsis" >{{ downloadingChat ? 'Preparing download…' : 'Download chat' }}</h3>
            </div>
          </li>
        </ul>
      </div>
    </b-popover>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import SBAvatar from '../../common/Avatar';
import AssignConversationInfoBox from '../../organisation/assign_conversation/InfoBox';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import ToasterMixin from '@/mixins/Toaster';
import randomString from '@/helpers/randomString';
import ChatEventBus from '@/components/business/chat/ChatEventBus';
import api from '@/helpers/api';

export default {
  name: 'MessagesHeader',
  components: {
    AssignConversationInfoBox,
    SBAvatar,
    SBIcon,
  },
  mixins: [
    ToasterMixin,
  ],
  data() {
    return {
      assignedMember: null,
      folderChangingAbility: true,
      messageActionButtonsOpened: false,
      showMemberList: false,
      userId: localStorage.getItem('userId'),
      memberQuery: '',
      blockMenuInfoPopover: false,
      movingToFolder: false,
      moveAnimationRunning: false,
      activeSection: null,
      isFollowing: false,
      downloadingChat: false,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      activeConversation: 'chat/activeConversation',
      conversationList: 'chat/conversationList',
      currentFolder: 'inbox/currentFolder',
      currentOrganisationTeamsTree: 'organisation/currentOrganisationTeamsTree',
      currentOrganisation: 'organisation/currentOrganisation',
      numberMembers: 'organisation/numberMembers',
      me: 'organisation/me',
      conversationActivity: 'pusher/conversationActivity',
      activeDetailsSection: 'contactDetails/activeDetailsSection',
      currentOrganisationMembersLookup: 'organisation/currentOrganisationMembersLookup',
    }),
    conversationIsBlocked() {
      return this.activeConversation && this.activeConversation.blocked;
    },
    teamList() {
      const record = this.currentOrganisationTeamsTree[this.activeConversation.business_id]; // <- this is no longer valid
      const result = record ? record.teams : [];

      // search
      const memberQuery = this.memberQuery.toLowerCase();
      // no search, return full list
      if (!memberQuery) {
        return result;
      }
      // search
      return result.map((team) => {
        const teamCopy = Object.assign({}, team);
        teamCopy.users = teamCopy.users.filter(user => (user.name.toLowerCase().indexOf(memberQuery) !== -1) ||
          (user.email.toLowerCase().indexOf(memberQuery) !== -1));

        return teamCopy;
      });
    },
    conversationIsUnread() {
      return this.activeConversation && (!this.activeConversation.seen || (!this.activeConversation.assignment_seen && (this.activeConversation.user_id === this.userId)));
    },
  },
  watch: {
    activeDetailsSection() {
      this.activeSection = this.activeDetailsSection;
    },
    activeConversation() {
      this.movingToFolder = false;
      this.preventFolderChange = false;
      if (this.activeConversation) {
        this.isFollowing = !!this.activeConversation.following;
      }
    },
    conversationActivity() {
      if (this.conversationActivity.conversation_uid === this.activeConversation.id) {
        switch (this.conversationActivity.activity.action) {
          case 'folder': {
            if (this.conversationActivity.activity.meta_data.new_folder !== this.activeConversation.folder) {
              this.preventFolderChange = true;
              this.activeConversation.folder = this.conversationActivity.activity.meta_data.new_folder;
            }
            break;
          }
          case 'assignment': {
            if (this.activeConversation) {
              this.activeConversation.user_id = this.conversationActivity.activity.to_user_id;
            }
            break;
          }
          case 'Block': {
            this.activeConversation.blocked = true;
            break;
          }
          case 'Unblock': {
            this.activeConversation.blocked = false;
            break;
          }
          case 'messaging_consent_disabled':
            this.activeConversation.contact.has_messaging_consent = false;
            break;
          default:
            break;
        }
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.activeDetailsSection) {
        this.activeSection = this.activeDetailsSection;
      }
      if (this.activeConversation) {
        this.isFollowing = !!this.activeConversation.following;
      }
    });
  },
  methods: {
    ...mapActions({
      // fetchTeams: 'team/fetchTeamList',
      markConversationAsSeen: 'chat/markConversationAsSeen',
      updateBotStatus: 'chat/updateBotStatus',
      updateBotStatusLocally: 'chat/updateBotStatusLocally',
      changeFolder: 'chat/changeFolder',
      blockContactVuex: 'contact/blockContact',
      removeConversationFromList: 'chat/removeConversationFromList',
      addMessageToFastLoad: 'chat/addMessageToFastLoad',
      addMessageToList: 'chat/addMessageToList',
      removeMessageFromList: 'chat/removeMessageFromList',
      activateSectionVuex: 'contactDetails/activateSection',
      conversationCacheUpdate: 'chat/conversationCacheUpdate',
      followConversation: 'chat/followConversation',
    }),
    ...mapMutations({
      REMOVE_BLOCKED_FLAG_FROM_CONVERSATION: 'chat/REMOVE_BLOCKED_FLAG_FROM_CONVERSATION',
      NEW_CONVERSATION_ACTIVITY: 'pusher/NEW_CONVERSATION_ACTIVITY',
      UPDATE_CONVERSATION_FOLLOWING: 'chat/UPDATE_CONVERSATION_FOLLOWING',
    }),
    activateSection(section) {
      if (this.activeSection !== section) {
        this.activeSection = section;
        this.activateSectionVuex(section);
      } else {
        this.activeSection = null;
        this.activateSectionVuex(null);
      }
      ChatEventBus.$emit('showUserDetails', this.activeSection);
      localStorage.setItem('contactDetailsView', this.activeSection);
    },
    hideMembers() {
      this.showMemberList = false;
    },
    hideMessageActions() {

    },
    moveToFolder(folder) {
      if (this.moveAnimationRunning || this.movingToFolder || !this.activeConversation || !this.activeConversation.contact) {
        return;
      }

      const stayInFolder = folder === this.currentFolder;
      const conversationBkp = { ...this.activeConversation };
      const payload = {
        business_uid: conversationBkp.business_id,
        conversation_uid: conversationBkp.id,
        activity: {
          sid: `temp-sid-${randomString()}`,
          timestamp: Math.floor(Date.now() / 1000),
          direction: 'activity',
          action: 'folder',
          from_user_id: this.me.id,
          to_user_id: this.activeConversation.user_id,
          meta_data: {
            old_folder: conversationBkp.folder,
            new_folder: folder,
          },
          conversation_id: conversationBkp.id,
        },
      };

      if (!stayInFolder) {
        this.movingToFolder = true;
        this.moveAnimationRunning = true;
        setTimeout(() => {
          this.moveAnimationRunning = false;
        }, 500);
        const name = this.activeConversation.contact.name ? this.activeConversation.contact.name : this.activeConversation.contact.phone;
        this.$eventBus.$emit('remove-conversation', conversationBkp.id);
      } else {
        this.activeConversation.folder = folder;
        this.addMessageToList(payload);
      }

      this.changeFolder({
        businessId: conversationBkp.business_id,
        conversationId: conversationBkp.id,
        data: {
          folder,
          noCancel: true,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            if (!stayInFolder) {
              this.$eventBus.$emit('conform-conversation-remove', conversationBkp.id);
            }
            this.addMessageToFastLoad(payload);
            this.conversationCacheUpdate(payload);
            this.NEW_CONVERSATION_ACTIVITY(payload);
          }
        })
        .catch(() => {
          if (!stayInFolder) {
            this.$eventBus.$emit('add-conversation', conversationBkp.id);
          } else {
            this.activeConversation.folder = conversationBkp.folder;
            this.removeMessageFromList(payload.activity.sid);
          }
          this.showToaster('There was an error. Please try again later.', null, null, 'warning');
        });

      if (this.$refs.donePopoverRef) {
        this.$refs.donePopoverRef.$emit('close');
      }
      if (this.$refs.reopenPopoverRef) {
        this.$refs.reopenPopoverRef.$emit('close');
      }
    },
    blockContact() {
      this.toggleMenu();
      this.blockContactVuex({
        businessId: this.activeConversation.business_id,
        conversationId: this.activeConversation.id,
        data: {
          block: 1,
          includeMe: true,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            this.activeConversation.blocked = true;
            // this.showToaster(`<span class="emoji-fix">🚫</span> ${conversation.contact.name ? conversation.contact.name : conversation.contact.phone} has been successfully blocked.`);
          }
        })
        .catch(() => {
          this.showToaster(`There was an error while blocking ${this.activeConversation.contact.name ? this.activeConversation.contact.name : this.activeConversation.contact.phone}. Try again later.`, this.SBIconList.ERROR, 'error');
        });
    },
    unblockContact() {
      this.toggleMenu();
      let message;
      if (this.activeConversation.contact.name) {
        message = `Are you sure you want to unblock contact <b>${this.activeConversation.contact.name}</b> ${this.$options.filters.phoneFormat(this.activeConversation.contact.phone)}?`;
      } else {
        message = `Are you sure you want to unblock contact <b>${this.$options.filters.phoneFormat(this.activeConversation.contact.phone)}</b>?`;
      }
      this.$confirmPluginModal.show({
        title: 'Unblock contact',
        message,
        confirmButtonText: 'Unblock',
        autoClose: 'true',
        confirmCallback: () => {
          this.blockContactVuex({
            businessId: this.activeConversation.business_id,
            conversationId: this.activeConversation.id,
            data: {
              block: '0',
              includeMe: true,
            },
          })
            .then((response) => {
              if (response.status === 200) {
                this.activeConversation.blocked = false;
                this.REMOVE_BLOCKED_FLAG_FROM_CONVERSATION(this.activeConversation.id);
                this.showToaster(`${this.activeConversation.contact.name ? this.activeConversation.contact.name : this.activeConversation.contact.phone} has been successfully unblocked.`, null, null, 'OK');
                this.$confirmPluginModal.close();
              }
            })
            .catch(() => {
              this.showToaster(`There was an error while unblocking ${this.activeConversation.contact.name ? this.activeConversation.contact.name : this.activeConversation.contact.phone}. Try again later.`, null, null, 'warning');
            });
        },
      });
    },
    toggleBotActivation() {
      const payload = {
        businessId: this.activeConversation.business_id,
        conversationId: this.activeConversation.id,
        data: {
          bot_active: !this.activeConversation.bot_active,
        },
      };

      const botState = !this.activeConversation.bot_active ? 'on' : 'off';

      this.updateBotStatus(payload)
        .then(() => {
          this.showToaster(`Bot turned ${botState}.`, null, null, 'OK');
        })
        .catch(() => {
          this.showToaster(`Bot failed to turn ${botState}. Please try again later.`, null, null, 'error');
          payload.data.bot_active = !payload.data.bot_active;
          this.updateBotStatusLocally(payload);
        });
      this.closeMenu();
    },
    toggleConversationSeen() {
      const seen = this.conversationIsUnread;
      const payload = {
        organisationId: this.currentOrganisation.id,
        merchant_id: this.activeConversation.business_id,
        conversation_id: this.activeConversation.id,
        folder: this.activeConversation.folder,
        data: {
          seen,
          includeMe: false,
        },
      };
      this.$set(this.activeConversation, 'addedToNumberUnreadCount', true);
      this.markConversationAsSeen(payload);
      this.closeMenu();
    },
    toggleMemberList() {
      if (this.currentFolder === 'open') {
        this.showMemberList = !this.showMemberList;

        if (this.showMemberList) {
          this.memberQuery = '';
        }
      }
    },
    toggleMessageActions() {},
    formatActivityMessage(message, contactLabel) {
      const lookup = this.currentOrganisationMembersLookup || {};
      const action = (message.data && message.data.action) || message.action || 'activity';
      const meta = message.meta_data || (message.data && message.data.meta_data) || {};
      const fromUser = message.from_user_id ? lookup[message.from_user_id] : null;
      const toUser = message.to_user_id ? lookup[message.to_user_id] : null;
      const fromName = fromUser && fromUser.name ? fromUser.name : 'Someone';
      const toName = toUser && toUser.name ? toUser.name : null;
      const capitalize = s => (typeof s === 'string' ? s.replace(/\b\w/g, l => l.toUpperCase()) : s);

      switch (action) {
        case 'assignment':
          return toName ? `${fromName} assigned conversation to ${toName}` : `${fromName} unassigned conversation`;
        case 'folder':
          return `${fromName} moved conversation from ${capitalize(meta.old_folder) || '?'} to ${capitalize(meta.new_folder) || '?'}`;
        case 'status_available':
          return `${fromName} changed conversation status to available`;
        case 'status_away':
          return `${fromName} changed conversation status to away`;
        case 'Block':
          return `🚫 ${fromName} blocked this contact`;
        case 'Unblock':
          return `👍 ${fromName} unblocked this contact`;
        case 'messaging_consent_disabled':
          return `⛔ ${contactLabel} opted-out from receiving messages`;
        case 'changed_number':
          return `📞 ${contactLabel} changed their WhatsApp number${meta.new_number ? ` to ${meta.new_number}` : ''}`;
        case 'voice_call_started':
          return '📞 Inbound call started';
        case 'voice_call_ended':
          return '📞 Inbound call ended';
        case 'ai_sent_email':
          return '✉️ Conversation summary sent to email';
        default:
          return action;
      }
    },
    formatChatMessage(message, contactLabel) {
      const ts = message.timestamp || message.sent_at;
      const time = ts ? this.$moment(ts * 1000).format('YYYY-MM-DD HH:mm:ss') : '';
      if (message.direction === 'activity') {
        return `[${time}] -- ${this.formatActivityMessage(message, contactLabel)}`;
      }
      const sender = message.direction === 'inbound' ? contactLabel : (message.sender || 'Agent');
      let body = message.body || '';
      if (!body && message.media_url) {
        const kind = message.media_type || message.type || 'media';
        body = `Media message [${kind}]`;
      } else if (!body && message.type && message.type !== 'text') {
        body = `Media message [${message.type}]`;
      }
      return `[${time}] ${sender}: ${body}`;
    },
    sanitizeFilename(value) {
      return String(value).replace(/[\\/:*?"<>|]+/g, '_').replace(/\s+/g, ' ').trim() || 'chat';
    },
    async fetchAllChatMessages() {
      const all = [];
      const seen = new Set();
      let cursor = Math.ceil(Date.now() / 1000) + 10000;
      const maxIterations = 200;

      for (let i = 0; i < maxIterations; i++) {
        const params = {
          older: 100,
          sent_at: cursor,
          destination: 'universal',
        };
        // eslint-disable-next-line no-await-in-loop
        const response = await api(
          'GET',
          `organisation/${this.currentOrganisation.id}/business/${this.activeConversation.business_id}/conversation/${this.activeConversation.id}/messages`,
          params,
          null,
          'w',
        );
        const batch = response && response.data && response.data.data ? response.data.data : [];
        if (!batch.length) {
          break;
        }
        let oldestTs = cursor;
        batch.forEach((message) => {
          const key = message.sid || message.id;
          if (key && seen.has(key)) {
            return;
          }
          if (key) {
            seen.add(key);
          }
          all.push(message);
          const ts = message.timestamp || message.sent_at;
          if (ts && ts < oldestTs) {
            oldestTs = ts;
          }
        });
        if (batch.length < 100 || oldestTs >= cursor) {
          break;
        }
        cursor = oldestTs;
      }

      return all.sort((a, b) => (a.timestamp || a.sent_at || 0) - (b.timestamp || b.sent_at || 0));
    },
    async downloadChat() {
      if (this.downloadingChat || !this.activeConversation || !this.activeConversation.id) {
        return;
      }
      this.downloadingChat = true;
      try {
        const contact = this.activeConversation.contact || {};
        const contactLabel = contact.name || contact.phone || 'Contact';
        const messages = await this.fetchAllChatMessages();

        const lines = messages.map(m => this.formatChatMessage(m, contactLabel));
        const content = lines.join('\n');

        const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', `${this.sanitizeFilename(contact.name || contact.phone)}.txt`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        this.showToaster('Failed to download chat. Please try again.', null, null, 'error');
      } finally {
        this.downloadingChat = false;
        this.closeMenu();
      }
    },
    toggleMenu() {
      if (this.$refs.menuPopoverRef && !this.$refs.menuPopoverRef.localShow) {
        this.$refs.menuPopoverRef.$emit('open');
        this.blockMenuInfoPopover = true;
      } else if (this.$refs.menuPopoverRef) {
        this.$refs.menuPopoverRef.$emit('close');
        this.blockMenuInfoPopover = false;
      }
    },
    closeMenu() {
      if (this.$refs.menuPopoverRef) {
        this.$refs.menuPopoverRef.$emit('close');
      }
      this.blockMenuInfoPopover = false;
    },
    handleFollowClick() {
      const newFollowState = !this.isFollowing;
      const payload = {
        businessId: this.activeConversation.business_id,
        conversationId: this.activeConversation.id,
        data: {
          follow: newFollowState ? 1 : 0,
        },
      };

      this.followConversation(payload)
        .then(() => {
          this.isFollowing = newFollowState;
          this.activeConversation.following = newFollowState;
          this.UPDATE_CONVERSATION_FOLLOWING({
            conversationId: this.activeConversation.id,
            following: newFollowState,
          });

          // Check if in My Chats, unfollowing, and not assigned to conversation
          const isInMyChats = ['OrganisationConversation', 'OrganisationWithId'].includes(this.$route.name);
          const isUnfollowing = !newFollowState;
          const isNotAssigned = this.activeConversation.user_id !== this.me.id;

          if (isInMyChats && isUnfollowing && isNotAssigned) {
            // Emit event to remove conversation from My Chats list
            this.$eventBus.$emit('unfollow-conversation', this.activeConversation.id);
          }

          if (this.isFollowing) {
            this.showToaster('You\'re now following this conversation.', null, null, 'OK');
          } else {
            this.showToaster('You\'re no longer following this conversation.', null, null, 'OK');
          }
        })
        .catch(() => {
          this.showToaster('There was an error. Please try again later.', null, null, 'warning');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.follow-popover-max-width {
  max-width: 250px;
}

#messages-header {
  display: flex;
  align-items: center;
  height: 54px;
  padding: 15px;

  .person-avatar {
    cursor: pointer;
    min-width: 30px;
    flex-shrink: 99999;

    &:hover ::v-deep .subtext {
      color: $blackPrimary;
    }
  }

  .btn {
    &.rounded-pill {
      margin: 0 0 0 10px;
      border-radius: 50rem !important;
    }
  }

  .action-btn {
    margin: 0 0 0 10px;
  }

  .assign-btn {
    max-width: calc(100% - 186px);
  }

  .assignment-select {
    .action-button {
      display: flex;
      p + img {
        margin-left: 7px;
      }
    }

    .rounded-button {
      padding: 5px 10px;
      margin-right: 10px;
      border-radius: 50px;
      border: solid 1px $greyBorder;
    }
    .rounded-button, .rounded-button p {
      // font-family: 'InterSB' !important;
      font-size: 14px;
      font-weight: 500;
      line-height: 1.2;
      color: $blackPrimary;
    }

    .dropdown-wrapper {
      position: relative;
      .assign-dropdown {
        position: absolute;
        right: 0;
        top: 33px;
        z-index: 900;
        width: 297px;
        border-radius: 5px;
        box-shadow: 0 2px 5px 0 rgba(13, 15, 22, 0.23);
        background-color: $white;

        .dropdown-header{
          padding: 15px;
          h3 {
            font-size: 14px;
            font-weight: 500;
            line-height: 1.37;
            text-align: center;
            color: $blackPrimary;
            margin: 0 0 15px;
          }

          .form-control {
            border-radius: 5px;
            box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.15);
          }
        }

        .dropdown-body {
          .team {
            margin-top: 16px;
            .team-title {
              padding-left: 15px;
              padding-bottom: 7px;
            }
            .team-member {
              display: flex;
              padding: 8px 15px;
              &:hover {
                background: $greyChatBubble;
              }
              .done-tick {
                display: block;
                width: 20px;
                height: 20px;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url('~@/assets/img/done-tick.svg');
              }
            }
          }
        }
      }
    }
  }

  .actions {
    padding: 15px;
    justify-content: flex-end;
    .action-button {
      display: inline-flex;
      margin: 0 16px;
      img {
        height: 20px;
      }
    }
    #done-icon img {
      height: 12px;
    }
  }
}
</style>

<style lang="scss" scoped>
.popover-offset-sb {
  margin-top: 5px !important;
  // margin-left: 22px !important;
  left: 12px !important;
}

.btn-popover-additional-margin {
  margin-top: 12px !important;
}

#select-branch {
  width: 297px;

  h5 {
    text-align: center;
    font-weight: 500;
    margin: 15px 16px 0;
  }

  .search-input-wrapper {
    position: relative;
    // border-bottom: solid 1px #e0e7e9;

    input {
      padding: 5px 26px 5px 8px;
      margin: 15px 16px 0;
      width: calc(100% - 30px);
      border-radius: 5px;
      box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.15) !important;
      border: solid 1px #cfd8dc !important;
      background-color: #ffffff !important;
      height: 26px !important;

      &:focus {
        box-shadow: 0 0 0 3px #bfdeff !important;
      }
    }

    .sb-icon {
      position: absolute;
      top: 5px;
      right: 20px;
    }
  }

  .branch-list {
    margin: 0;
    margin-top: 15px;
    padding: 7px 0;
    border-radius: 0 0 5px 5px;
    border-top: solid 1px #e0e7e9;
    overflow: hidden;
    max-height: 232px;
    overflow-y: auto;

    li {
      padding: 12px 16px;
      .branch-icon {
        display: inline-block;
      }

      &:hover {
        background: $hover;
        cursor: pointer;
      }
    }

    .branch-not-found {
      display: block;
      padding: 0 16px;
    }
  }

  .branch-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 32px;
    min-width: 32px;
    border-radius: 5px;
    border: solid 1px #dde6e9;
    background-color: $white;

    .branch-icon {
      font-size: 14px !important;
      // letter-spacing: 3px !important;
    }
  }

  .option-info {

    .sb-icon {
      margin-right: 10px;
    }

    h3 {
      font-size: 14px;
      font-weight: 400;
      color: $blackPrimary;
    }

    p {
      font-size: 12px;
      font-weight: 400;
      color: $greyPrimary;
      margin-top: 2px;
    }
  }
}
</style>
